

























import VueOptions from '@utils/VueOptions'

settings = 
  name: 'PaperworkRequirement'
  resources:
    paperwork_requirement:
      resourceName: "paperwork_requirement"
      slug: "advances/:advanceId/paperwork_requirements/:requirementId/edit"
  vue:
    props: ['requirementId']
    computed:
      isAcknowledged: -> @prime.paperwork_requirement.brand_acknowledged
    methods:
      toggleAcknowledgement: ->
        @prime.paperwork_requirement.brand_acknowledged = !@prime.paperwork_requirement.brand_acknowledged
        @saveItem 'paperwork_requirement', @prime.paperwork_requirement
      updateRequirement: -> 
        @saveItem 'paperwork_requirement', @prime.paperwork_requirement
      onSave: -> console.log 'saved paperwork_requirmeent'

export default VueOptions.vue settings
